import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Route } from 'react-router-dom'
import CandidatesList from 'components/candidatesList'

// const ARTICLE_ID = '00000000'

export class AppComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedCoatOfArms: 'geneve',
      selectedElection: '2020-03-GE-geneve'
    }

    this.onSelect = this.onSelect.bind(this)
  }

  onSelect(event) {
    console.log(event.target)
    this.setState({
      selectedCoatOfArms: event.target.value,
      selectedElection: '2020-03-GE-' + event.target.value
    })
  }

  render() {
    const options = [
      { value: '2020-03-GE-geneve', className: 'geneve', label: 'Genève' },
      { value: '2020-03-GE-vernier', className: 'vernier', label: 'Vernier' },
      { value: '2020-03-GE-lancy', className: 'lancy', label: 'Lancy' },
      { value: '2020-03-GE-meyrin', className: 'meyrin', label: 'Meyrin' },
      { value: '2020-03-GE-carouge', className: 'carouge', label: 'Carouge' },
      { value: '2020-03-GE-onex', className: 'onex', label: 'Onex' },
      { value: '2020-03-GE-thonex', className: 'thonex', label: 'Thônex' },
      { value: '2020-03-GE-versoix', className: 'versoix', label: 'Versoix' },
      {
        value: '2020-03-GE-le_grand_saconnex',
        className: 'le_grand_saconnex',
        label: 'Le Grand-Saconnex'
      },
      {
        value: '2020-03-GE-chenes_bougeries',
        className: 'chenes_bougeries',
        label: 'Chênes-Bougeries'
      },
      { value: '2020-03-GE-veyrier', className: 'veyrier', label: 'Veyrier' },
      {
        value: '2020-03-GE-plan_les_ouates',
        className: 'plan_les_ouates',
        label: 'Plan-les-Ouates'
      },
      { value: '2020-03-GE-bernex', className: 'bernex', label: 'Bernex' }
    ]

    return (
      <div className='index'>
        <ThemeSwitch />
        <Route
          exact
          path='/'
          render={props => (
            <>
              <div className='ui text container'>
                <div className='ui very fitted vertical segment'>
                  <div className='select-container'>
                    <select
                      onChange={value => {
                        this.onSelect(value)
                      }}
                    >
                      {options.map((option, i) => (
                        <option key={'option-' + i} value={option.className}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className='coat-of-arms'>
                      <img
                        src={require('../../images/' +
                          this.state.selectedCoatOfArms +
                          '.jpg')}
                      />
                    </div>
                    <i className='ui icon chevron down' />
                  </div>
                </div>
              </div>
              <CandidatesList
                {...props}
                match={{ params: { electionId: this.state.selectedElection } }}
              />
            </>
          )}
        />
        <Route
          exact
          path='/:electionId'
          render={props => (
            <>
              <CandidatesList {...props} />
            </>
          )}
        />
      </div>
    )
  }
}
